import {
  Home, Building2, Castle, TreePine, Mountain,
  Waves, Sun, Coffee, Star, MapPin, Key, Tent,
  Snowflake, Flame, Anchor, Bike, Palmtree, Leaf,
  Sailboat, Wine, Hotel, Warehouse, Landmark,
  Utensils, Pizza, Beer, Martini, Croissant,
  Flower, Flower2, Trees, Car, Train, Plane, Ship,
  Sunset, Sunrise, Cloud, CloudRain, CloudSnow,
  Umbrella, Wind, Dog, Cat, Bird, Rabbit,
  Diamond, Crown, Gem, Trophy, Music, Guitar,
  Camera, Paintbrush, Heart, Globe, Compass,
  Map, Flag, Navigation, Sparkles, Moon,
  Dumbbell, Target, CupSoda,
  BedDouble, Sofa, Bath, ShowerHead,
  UtensilsCrossed, ChefHat, CookingPot,
  TreeDeciduous, Fence, Sprout, SunMedium, Droplets,
  Shell, Binoculars, Telescope, Flashlight,
  SportShoe, Lamp,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { resolveIcon as resolveMultiPackIcon } from "@/lib/icon-registry";

export const PROPERTY_ICONS: { id: string; Icon: LucideIcon; label: string }[] = [
  // Housing
  { id: "home",            Icon: Home,             label: "Home"          },
  { id: "building-2",      Icon: Building2,        label: "Building"      },
  { id: "castle",          Icon: Castle,           label: "Castle"        },
  { id: "hotel",           Icon: Hotel,            label: "Hotel"         },
  { id: "warehouse",       Icon: Warehouse,        label: "Warehouse"     },
  { id: "landmark",        Icon: Landmark,         label: "Landmark"      },
  { id: "bed-double",      Icon: BedDouble,        label: "Bedroom"       },
  { id: "sofa",            Icon: Sofa,             label: "Living Room"   },
  { id: "bath",            Icon: Bath,             label: "Bath"          },
  { id: "shower-head",     Icon: ShowerHead,       label: "Shower"        },
  // Nature
  { id: "tree-pine",       Icon: TreePine,         label: "Forest"        },
  { id: "tree-deciduous",  Icon: TreeDeciduous,    label: "Tree"          },
  { id: "trees",           Icon: Trees,            label: "Woods"         },
  { id: "mountain",        Icon: Mountain,         label: "Mountain"      },
  { id: "leaf",            Icon: Leaf,             label: "Nature"        },
  { id: "flower",          Icon: Flower,           label: "Flower"        },
  { id: "flower-2",        Icon: Flower2,          label: "Garden"        },
  { id: "sprout",          Icon: Sprout,           label: "Sprout"        },
  { id: "fence",           Icon: Fence,            label: "Backyard"      },
  // Water
  { id: "waves",           Icon: Waves,            label: "Beach"         },
  { id: "droplets",        Icon: Droplets,         label: "Waterfront"    },
  { id: "anchor",          Icon: Anchor,           label: "Marina"        },
  { id: "sailboat",        Icon: Sailboat,         label: "Lake"          },
  { id: "shell",           Icon: Shell,            label: "Shore"         },
  // Weather/Ambience
  { id: "sun",             Icon: Sun,              label: "Resort"        },
  { id: "sun-medium",      Icon: SunMedium,        label: "Sunny"         },
  { id: "sunset",          Icon: Sunset,           label: "Sunset"        },
  { id: "sunrise",         Icon: Sunrise,          label: "Sunrise"       },
  { id: "moon",            Icon: Moon,             label: "Night"         },
  { id: "snowflake",       Icon: Snowflake,        label: "Winter"        },
  { id: "cloud",           Icon: Cloud,            label: "Cloud"         },
  { id: "cloud-rain",      Icon: CloudRain,        label: "Rain"          },
  { id: "cloud-snow",      Icon: CloudSnow,        label: "Snow"          },
  { id: "umbrella",        Icon: Umbrella,         label: "Umbrella"      },
  { id: "wind",            Icon: Wind,             label: "Windy"         },
  // Food & Drink
  { id: "coffee",          Icon: Coffee,           label: "Cottage"       },
  { id: "wine",            Icon: Wine,             label: "Vineyard"      },
  { id: "beer",            Icon: Beer,             label: "Pub"           },
  { id: "martini",          Icon: Martini,          label: "Bar"           },
  { id: "utensils",        Icon: Utensils,         label: "Dining"        },
  { id: "utensils-crossed",Icon: UtensilsCrossed,  label: "Restaurant"    },
  { id: "chef-hat",        Icon: ChefHat,          label: "Kitchen"       },
  { id: "pizza",           Icon: Pizza,            label: "Pizzeria"      },
  { id: "croissant",       Icon: Croissant,        label: "Cafe"          },
  { id: "cooking-pot",     Icon: CookingPot,       label: "Cooking"       },
  // Activities
  { id: "bike",            Icon: Bike,             label: "Cycling"       },
  { id: "sport-shoe",      Icon: SportShoe,        label: "Active"        },
  { id: "dumbbell",        Icon: Dumbbell,         label: "Gym"           },
  { id: "cup-soda",        Icon: CupSoda,          label: "Pool"          },
  { id: "lamp",            Icon: Lamp,             label: "Cozy Lamp"     },
  { id: "target",          Icon: Target,           label: "Target"        },
  { id: "compass",         Icon: Compass,          label: "Adventure"     },
  // Travel
  { id: "map-pin",         Icon: MapPin,           label: "Location"      },
  { id: "map",             Icon: Map,              label: "Map"           },
  { id: "navigation",      Icon: Navigation,       label: "Navigate"      },
  { id: "plane",           Icon: Plane,            label: "Airport"       },
  { id: "car",             Icon: Car,              label: "Drive"         },
  { id: "train",           Icon: Train,            label: "Transit"       },
  { id: "ship",            Icon: Ship,             label: "Harbor"        },
  // Special
  { id: "key",             Icon: Key,              label: "Rental"        },
  { id: "tent",            Icon: Tent,             label: "Camping"       },
  { id: "flame",           Icon: Flame,            label: "Cozy"          },
  { id: "palmtree",        Icon: Palmtree,         label: "Tropical"      },
  { id: "star",            Icon: Star,             label: "Luxury"        },
  { id: "diamond",         Icon: Diamond,          label: "Premium"       },
  { id: "crown",           Icon: Crown,            label: "Royal"         },
  { id: "gem",             Icon: Gem,              label: "Gem"           },
  { id: "trophy",          Icon: Trophy,           label: "Top Rated"     },
  { id: "sparkles",        Icon: Sparkles,         label: "Special"       },
  { id: "heart",           Icon: Heart,            label: "Favorite"      },
  { id: "flag",            Icon: Flag,             label: "Flag"          },
  { id: "globe",           Icon: Globe,            label: "Global"        },
  { id: "binoculars",      Icon: Binoculars,       label: "Scenic View"   },
  { id: "telescope",       Icon: Telescope,        label: "Observatory"   },
  { id: "flashlight",      Icon: Flashlight,       label: "Outdoors"      },
  // Animals
  { id: "dog",             Icon: Dog,              label: "Pet-Friendly"  },
  { id: "cat",             Icon: Cat,              label: "Cats OK"       },
  { id: "bird",            Icon: Bird,             label: "Bird"          },
  { id: "rabbit",          Icon: Rabbit,           label: "Rabbit"        },
  // Art & Music
  { id: "music",           Icon: Music,            label: "Music"         },
  { id: "guitar",          Icon: Guitar,           label: "Guitar"        },
  { id: "camera",          Icon: Camera,           label: "Photo"         },
  { id: "paintbrush",      Icon: Paintbrush,       label: "Art"           },
];

// Accepts both legacy bare kebab ids ("home", "bed-double") and namespaced
// keys written by the new multi-pack icon picker ("lucide:home",
// "tabler:bath", "phosphor:bathtub"). Falls back to the multi-pack resolver
// for non-lucide / non-curated keys.
export function getPropertyIcon(id: string | null | undefined): LucideIcon {
  if (!id || typeof id !== "string") return Home;
  // Strip a leading "lucide:" prefix so the curated PROPERTY_ICONS map still
  // matches existing rows.
  const bare = id.startsWith("lucide:") ? id.slice("lucide:".length) : id;
  const direct = PROPERTY_ICONS.find((i) => i.id === bare)?.Icon;
  if (direct) return direct;
  // Multi-pack fallback (tabler / phosphor / any lucide id outside the
  // curated property list). resolveMultiPackIcon is guaranteed non-undefined.
  const fallback = resolveMultiPackIcon(id);
  return (fallback ?? Home) as LucideIcon;
}
